
import Card from '../../../components/base/Card';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-time-fill',
      title: 'Servicio 24/7',
      description: 'Estamos disponibles las 24 horas del día, los 7 días de la semana para atender tus pedidos.',
      features: ['Atención nocturna', 'Fines de semana', 'Días festivos', 'Sin recargo adicional']
    },
    {
      icon: 'ri-truck-fill',
      title: 'Entrega Rápida',
      description: 'Entregamos tu pedido en 30-45 minutos en toda Bogotá con nuestro equipo especializado.',
      features: ['30-45 minutos', 'Seguimiento en tiempo real', 'Entregadores capacitados', 'Productos refrigerados']
    },
    {
      icon: 'ri-map-pin-fill',
      title: 'Cobertura Total',
      description: 'Llegamos a todas las localidades de Bogotá sin excepción, desde el centro hasta la periferia.',
      features: ['Todas las localidades', 'Zona norte y sur', 'Zona centro y occidente', 'Zona oriente']
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Productos Originales',
      description: 'Garantizamos la autenticidad de todos nuestros productos con certificados de calidad.',
      features: ['100% originales', 'Certificados de calidad', 'Fechas de vencimiento', 'Almacenamiento adecuado']
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Precios Competitivos',
      description: 'Ofrecemos los mejores precios del mercado con promociones y descuentos especiales.',
      features: ['Precios justos', 'Promociones semanales', 'Descuentos por volumen', 'Sin costos ocultos']
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Atención Personalizada',
      description: 'Nuestro equipo te asesora para elegir el producto perfecto según tus necesidades.',
      features: ['Asesoría experta', 'Recomendaciones', 'Atención al cliente', 'Soporte técnico']
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos un servicio integral de entrega a domicilio con la más alta calidad y 
            profesionalismo en cada uno de nuestros procesos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} hover className="p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-red-100 rounded-full">
                <i className={`${service.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center justify-center text-sm text-gray-700">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-check-fill text-green-600"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">¿Necesitas Asesoría?</h3>
          <p className="text-xl mb-8 text-red-100">
            Contáctanos al 310 255 1833, 333 248 3675 o 321 258 5307 para ayudarte a elegir el producto perfecto
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => window.open('https://wa.me/573102551833', '_blank')}
              className="bg-white text-red-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2 inline-flex">
                <i className="ri-whatsapp-fill"></i>
              </div>
              WhatsApp 310 255 1833
            </button>
            <button 
              onClick={() => window.open('https://wa.me/573332483675', '_blank')}
              className="bg-white text-red-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2 inline-flex">
                <i className="ri-whatsapp-fill"></i>
              </div>
              WhatsApp 333 248 3675
            </button>
            <button 
              onClick={() => window.open('https://wa.me/573212585307', '_blank')}
              className="bg-white text-red-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2 inline-flex">
                <i className="ri-whatsapp-fill"></i>
              </div>
              WhatsApp 321 258 5307
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
